import type { SelectOption } from './Select.tsx';

export const chooseNativeValue = (select: HTMLSelectElement, value: string): void => {
  if (select.value === value) return;
  select.value = value;
  select.dispatchEvent(new Event('input', { bubbles: true }));
  select.dispatchEvent(new Event('change', { bubbles: true }));
};

export const OPENING_KEYS: ReadonlySet<string> = new Set(['Enter', ' ', 'ArrowDown', 'ArrowUp', 'F4']);

export const stepFrom = (options: readonly SelectOption[], from: number, step: number): number => {
  if (options.length === 0) return -1;
  return (from + step + options.length) % options.length;
};

export const typedMatch = (options: readonly SelectOption[], from: number, key: string): number => {
  const letter = key.toLocaleLowerCase();
  const ordered = [...options.slice(from + 1), ...options.slice(0, from + 1)];
  const found = ordered.find((option) => option.label.toLocaleLowerCase().startsWith(letter));
  return found === undefined ? from : options.indexOf(found);
};
